import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';
import { withStyles } from '@material-ui/core';
import { withFeatureToggles } from 'shell/hoc/withFeatureToggles';
import { CLIENT_NEW_GROUP_DETAILS_PAGE } from 'constants/featureToggleNames';
import GroupsSearchModal from './GroupsSearchModal';
import styles from './GroupsSearchModal.styles';
import { fetchClientGroups, fetchGroupClients } from '../../modules/clients/actions';

const mapStateToProps = ({
  clientsModule: {
    groups: { data, loading: clientsGroupsLoading },
  },
}) => ({
  clientsGroupsLoading,
  clientsGroups: data.filter((group) => !group.defaultGroup),
});

const mapDispatchToProps = (dispatch, { isGroupV2Enabled }) => {
  const getClientGroups = () => fetchClientGroups({ isApiV2: isGroupV2Enabled, includeStats: !isGroupV2Enabled });
  return bindActionCreators({ getClientGroups, fetchGroupClients }, dispatch);
};

export default compose(
  withStyles(styles),
  withFeatureToggles({
    isGroupV2Enabled: CLIENT_NEW_GROUP_DETAILS_PAGE,
  }),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(GroupsSearchModal);
